import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Sparkles, User, Mail, Lock, ArrowRight, Loader2, Gift } from 'lucide-react';
import api from '../utils/api';

export default function Register() {
  const [form, setForm] = useState({ username: '', email: '', password: '', ref: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) setForm(f => ({ ...f, ref: ref.toUpperCase() }));
  }, []);

  const submit = async e => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await api.post('/auth/register', form);
      localStorage.setItem('token', res.data.token);
      navigate('/studio');
    } catch (e) {
      setError(e.response?.data?.error || '注册失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4
                    bg-[#f4f1e9] dark:bg-[#0e0e10] transition-colors duration-200">
      <div className="relative w-full max-w-sm">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-[#8c7db0] dark:bg-[#8f7fd0]
                          flex items-center justify-center shadow-xl shadow-[#8c7db0]/20 mb-4">
            <Sparkles size={24} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-[#2e2a24] dark:text-gray-100">
            小影
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-500 mt-1">AI 短剧创作平台</p>
        </div>

        {/* Card */}
        <div className="bg-[#fbfaf6] border border-[#ded6c8] rounded-2xl shadow-xl shadow-[#d6cbb7]/60 p-7
                        dark:bg-[#14141a] dark:border-white/[0.07] dark:shadow-none">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-6">创建账号</h2>

          {error && (
            <div className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-600
                            dark:bg-red-500/10 dark:border-red-500/20 dark:text-red-400
                            rounded-xl px-4 py-3 mb-5 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={submit} className="space-y-4">
            <div className="relative">
              <User size={15} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-600 pointer-events-none" />
              <input
                className="input pl-10"
                placeholder="用户名"
                value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })}
                required
              />
            </div>
            <div className="relative">
              <Mail size={15} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-600 pointer-events-none" />
              <input
                className="input pl-10"
                type="email"
                placeholder="邮箱"
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
                required
              />
            </div>
            <div className="relative">
              <Lock size={15} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-600 pointer-events-none" />
              <input
                className="input pl-10"
                type="password"
                placeholder="密码"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                required
              />
            </div>

            {/* Referral code field */}
            <div className="relative">
              <Gift size={15} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-600 pointer-events-none" />
              <input
                className="input pl-10"
                placeholder="推荐码（选填）"
                value={form.ref}
                onChange={e => setForm({ ...form, ref: e.target.value.toUpperCase() })}
                maxLength={10}
              />
            </div>

            <button
              className="btn-primary w-full py-3 flex items-center justify-center gap-2 mt-2"
              disabled={loading}
            >
              {loading
                ? <><Loader2 size={16} className="animate-spin" />注册中...</>
                : <>创建账号 <ArrowRight size={16} /></>
              }
            </button>
          </form>

          <p className="text-sm text-center mt-5 text-gray-500 dark:text-gray-500">
            已有账号？{' '}
            <Link to="/login" className="text-[#6f6196] dark:text-[#b9afe7] hover:underline font-medium">
              立即登录
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
